import { css } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'

export const footerWrapper = css({
  alignContent: 'center',
  color: '#606770',
  fontFamily: fonts.sansSerif,
  fontSize: fontSizes.medium,
  height: 42,
  margin: '0 16px',
})

export const footer = css({
  display: 'flex',
  justifyContent: 'space-between',
  listStyle: 'none',
  margin: '12px 15px 12px 20px',
  padding: 0,
})

export const footerItem = css({
  alignItems: 'center',
  display: 'flex',
  fontWeight: fontWeights.bold,
  gap: 8,
  svg: {
    paddingBottom: 2,
  },
})
